import { articles } from '@/mocks/navigation';
import ArticleCard from '@/components/base/ArticleCard';

export default function LatestArticles() {
  return (
    <section className="py-10 md:py-14">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">最新文章</h2>
            <p className="mt-1.5 text-sm text-foreground-600">互联网资讯、实用技巧与行业观察</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {articles.map((article) => (
            <ArticleCard
              key={article.slug}
              slug={article.slug}
              title={article.title}
              excerpt={article.excerpt}
              date={article.date}
              categoryName={article.categoryName}
              categorySlug={article.category}
            />
          ))}
        </div>
      </div>
    </section>
  );
}